<template>
  <v-container
    class="baaderbank-trades-container"
    fluid
  >
    <h1>Baaderbank Trade's State Management</h1>
    <BaaderbankConfirmTrades
      v-if="trades"
      :trades="trades"
      :loading="loading"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { toQueryString } from '@/helpers';
import { BaaderbankConfirmTrades } from '@/components/trades';

export default {
  name: 'BaaderbankConfirmTradesView',
  components: {
    BaaderbankConfirmTrades,
  },
  computed: {
    ...mapState({
      loading: state => state.baaderBankConfirmStore.loading,
      trades: state => state.baaderBankConfirmStore.trades,
    }),
  },
  async mounted() {
    this.fetchBaaderConfirmingTrades(toQueryString(this.$route.query));
  },
  methods: {
    ...mapActions(['fetchBaaderConfirmingTrades']),
  },
};
</script>


<style lang="scss" scoped>
.baaderbank-trades-container{
  max-width: 1500px;
}
</style>



// WEBPACK FOOTER //
// src/views/trades/BaaderbankConfirmTradesView.vue